/* ═══════════════════════════════════════════════════════════════
   Project dashboard widget registry — every widget def, imported
   individually (not via the category barrels) so this array can hold
   the exact first-visit order: Details · Phase · Attention ·
   Deliverables · Tasks · Team · Specs · Master updates (opt-in, added
   from the picker) · Design brief · Budget ·
   Forecast · Invoices (Project Canvas R1 Decision 1: Details, Phase
   and Design brief move from page chrome — the old ProjectPanel.tsx —
   into three stock widgets; 8 → 11 stock widgets. Widgets R2 Decision
   5: Forma folds into Specs as a strip, Profitability folds into
   Budget as a section).
   ═══════════════════════════════════════════════════════════════ */
import type { ProjectWidgetDef } from './context';
import { detailsWidget } from './details-widget';
import { projectTokensWidget } from './project-tokens-widget';
import { phaseWidget } from './phase-widget';
import { attentionWidget } from './attention-widget';
import { deliverablesWidget } from './deliverables-widget';
import { tasksWidget } from './tasks-widget';
import { teamWidget } from './team-widget';
import { specsWidget } from './specs-widget';
import { masterUpdatesWidget } from './master-updates-widget';
import { designBriefWidget } from './design-brief-widget';
import { budgetWidget } from './budget-widget';
import { forecastOutlookWidget } from './forecast-outlook-widget';
import { invoicesWidget } from './invoices-widget';

export const projectWidgets: ProjectWidgetDef[] = [
  detailsWidget,
  projectTokensWidget,
  phaseWidget,
  attentionWidget,
  deliverablesWidget,
  tasksWidget,
  teamWidget,
  specsWidget,
  masterUpdatesWidget,
  designBriefWidget,
  budgetWidget,
  forecastOutlookWidget,
  invoicesWidget,
];
